import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--chat-background);
  width: 100%;
  height: 95%;
  justify-content: start;
  overflow-y: scroll;

  @media (max-width: 768px) {
    height: 38vh;
  }

  .GlossaryHeader{
    width: 100%;
    height: 100px;
    background-color: var(--dark-blue);
    color: var(--white);
    display: flex;
    align-items: center;
    font-family: roboto, sans-serif;
    justify-content: center;
    font-size: 1.5em;
    font-weight: 300;
    line-height: 28px;
    border: 1px solid var(--white);

    @media(max-width: 768px){
      display: none;
    }
  }

  header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffffff;
    gap: 0.625rem;
    padding: 0 3%;
    width: 100%;
    color:#000000;
    font-size: 1.25em;
    font-weight: bold;
    border-radius: 2px 2px 0 0;
    height: 3rem;

    @media (max-width: 768px){
      width: 100%;
    }
  }

  .GlossarySearch {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 3rem;
    padding: 2rem 3rem;
    margin-left: -3px;
  }

  .SearchForm {
    cursor: pointer;
    background-color: var(--white);
    color: var(--primary-blue);
    width: 50%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      width: 100%;
    }
  }

  .CompleteChatLoading {
    display: flex;
    color: var(--white);
    justify-content: center;
    align-items: center;
  }

  .input {
    width: 90%;
    height: 2.5rem;
    font-size: 18px;
    background-color: var(--white);
    border: 1px solid var(--white);
    color: var(--dark-blue);
    font-weight: 400;
    line-height: 50px;
    padding-left: 8px;  
  }

  .spanNotFound {
    font-size: 1em;
    color: var(--gray);
    display: flex;
    justify-content: flex-start;
  }

  .GlossaryItems {
    background-color: var(--chat-background);
    padding-bottom: 1rem;

    ::-webkit-scrollbar {
      width: 0.375rem;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 0.313rem grey;
      border-radius: 0.625rem;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: var(--scrollbar);
      border-radius: 0.625rem;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: var(--gray);
    }
  }

  .Icon {
    padding-left: 8px;
    z-index: 3;
  }
`;

export const ButtonHomeGlossary = styled.button`
  background: none;
  color: var(--white);
  border-color: var(--white);
  border-width: thin;
  height: 3rem;
  width: 3rem;
  margin-right: 1.75rem;
`;

export const ButtonSubmit = styled.button`
  background-color: var(--chat-background);
  color: var(--white);
  border: 1px solid var(--white);
  font-size: 1em;
  height: 48px;
  padding: 8px;
`;

export const NextPageButton = styled.button`
  background: none;
  color: var(--primary-blue);
  border: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
`;

export const PreviousPageButton = styled.button`
  background: none;
  color: var(--primary-blue);
  border: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
`;

export const SkipFirstPageButton = styled.button`
  background: none;
  color: var(--primary-blue);
  border: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
`;

export const SkipLastPageButton = styled.button`
  background: none;
  color: var(--primary-blue);
  border: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: var(--white);
  width: 100%;
  height: 40px;

  @media(max-width: 768px){
    margin-bottom: 5rem;
    height: 30px;
  }

  .countPages {
    font-size: 0.9rem;
    color: #000000;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 1rem;
  background-color: var(--primary-blue);
  color: var(--white);
  padding: 1.5rem 2rem;
  width: 100%;

  .back-button {
    position: absolute;
    left: 2rem;
    background: none;
    border: none;
    cursor: pointer;
  }

  h1 {
    font-size: 1.7rem;
    margin: 0;
  }

  img {
    width: 1.5rem;
    height: 1.5rem;
  }
`;